import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Fiftyseaterbusonrentinpune() {



  const cardData =
  {
    keyword: '50 Seater Bus On Rent in Pune',
    heading: 'Amruta Travels: 50 Seater Bus On Rent in Pune',
    headingDescription: 'Amruta Travels Pvt. Ltd. provides 50 Seater Bus on Rent in Pune, offering the perfect combination of comfort, space, and reliability for large group travel. Ideal for corporate events, school trips, wedding transportation, and long-distance tours, our 50-seater luxury buses come equipped with push-back seats, efficient air conditioning, ample luggage storage, and wide panoramic windows for a relaxed and scenic journey. Every vehicle is meticulously maintained and driven by professional chauffeurs to ensure a safe, smooth, and punctual ride. Whether you’re traveling within Pune or heading to destinations like Mahabaleshwar, Goa, Shirdi, or Nashik, Amruta Travels’ 50 Seater Bus Rental in Pune guarantees a premium travel experience with unmatched service, comfort, and affordability.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
  {
    "title": "Sinhagad Fort",
    "description": "Perched on a rugged hill about 30 km from the city, Sinhagad Fort offers breathtaking views of the Sahyadri ranges. The fort is famed for the heroic battle led by Tanaji Malusare under Chhatrapati Shivaji Maharaj’s command. Visitors enjoy trekking, exploring ancient ruins, and savoring local snacks like pithla-bhakri. Sinhagad Fort embodies Pune’s valor, nature, and nostalgia in one frame."
  },
    {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark, visited by millions of devotees annually. Its magnificently decorated Lord Ganesha idol radiates devotion and serenity. During Ganesh Chaturthi, the temple comes alive with lights, chants, and celebrations. It stands as Pune’s beacon of faith and divine grace in the heart of the city."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering a blend of spirituality and scenic beauty. The temple complex atop the hill, dedicated to Lord Shiva and Goddess Parvati, was built by the Peshwas. Climbing its 108 steps rewards visitors with panoramic city views and a peaceful ambiance. Parvati Hill is Pune’s perfect fusion of devotion, history, and natural charm."
  },
    {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is an architectural masterpiece and a national monument of India’s freedom movement. Constructed in 1892, it served as a detention site for Mahatma Gandhi and his associates during the Quit India Movement. The palace’s sprawling gardens, museum, and Gandhi memorial exude peace and history. It is Pune’s enduring tribute to the nation’s struggle for independence."
  },
   {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada stands as the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas. Once the seat of the Maratha Empire, it boasts grand gates, intricately carved arches, and sprawling courtyards. The evening light and sound show vividly narrates tales of valor and tragedy. With its rich history and majestic aura, Shaniwar Wada remains the soul of Pune’s cultural identity."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut shrine carved out of basalt in the 8th century. Dedicated to Lord Shiva, the temple’s circular Nandi pavilion and stone pillars display remarkable craftsmanship. Nestled in the city center, it provides a tranquil escape from urban life. Pataleshwar Temple connects modern Pune to its timeless spiritual legacy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of over 20,000 rare artifacts collected from across India. From musical instruments to traditional ornaments and sculptures, it offers a fascinating glimpse into India’s past. Each exhibit tells a story of art, culture, and human creativity. It’s a must-visit cultural gem for those exploring Pune’s heritage."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a serene sanctuary that draws visitors from all over the world. Set amid lush gardens and modern architecture, it offers meditation, wellness programs, and personal growth workshops. The peaceful environment helps people reconnect with their inner selves. Osho Ashram is Pune’s global destination for spirituality and transformation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a picturesque reservoir surrounded by rolling hills and greenery, just a short drive from Pune. It’s the main water source for the city and a favorite spot for picnics and evening drives. The scenic view of shimmering waters during sunset is mesmerizing. Khadakwasla offers Pune residents the perfect weekend retreat close to nature."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "The Pune Okayama Friendship Garden, inspired by Japan’s famous Korakuen Garden, blends Japanese landscaping with Indian flora. Its lush lawns, small bridges, flowing streams, and walking paths create a soothing environment for relaxation. Named after writer Pu La Deshpande, it’s ideal for families and photographers alike. The garden represents Pune’s bond of global friendship and aesthetic beauty."
  }
],



     "services": [
    {
      "name": "50 Seater Bus On Rent in Pune",
      "description": "50 Seater Bus On Rent in Pune provides spacious and comfortable buses ideal for large groups, corporate outings, school trips, and social events across Pune. These buses come with ample seating and luggage space, ensuring a safe and relaxed journey. With professional drivers familiar with Pune's routes and traffic conditions, the service guarantees timely pickups and drop-offs, making group travel convenient and hassle-free."
    },
    {
      "name": "50 Seater AC Bus Pune",
      "description": "50 Seater AC Bus Pune offers fully air-conditioned buses designed for comfort during Pune's warm weather and long-distance travel. These buses feature modern cooling systems and comfortable seating to ensure a pleasant experience for passengers. Ideal for corporate events, weddings, and leisure tours, this service combines comfort, punctuality, and professional drivers to deliver premium transportation solutions."
    },
    {
      "name": "50 Seater Non AC Bus Pune",
      "description": "50 Seater Non AC Bus Pune provides economical and reliable transportation without air conditioning, perfect for budget-conscious travelers or short-distance city trips. These well-maintained non-AC buses ensure safety and cleanliness with experienced drivers committed to punctuality and courteous service. This option is suitable for school outings, local events, and affordable group travel within Pune."
    },
    {
      "name": "50 Seater Luxury Bus Pune",
      "description": "50 Seater Luxury Bus Pune features high-end buses with plush interiors, enhanced seating comfort, and premium amenities such as entertainment systems and Wi-Fi. These luxury buses are perfect for weddings, corporate events, and VIP group travel. Professional chauffeurs provide discreet, attentive service, ensuring a refined and memorable journey for discerning clients seeking the best in group transportation."
    },
    {
      "name": "50 Seater Bus Hire Pune",
      "description": "50 Seater Bus Hire Pune offers flexible rental options for group travel, accommodating various needs including corporate outings, school trips, family functions, and tours. The buses are spacious, well-maintained, and driven by professional drivers who prioritize safety and timely service. This service aims to deliver seamless and convenient transportation solutions tailored to customer requirements."
    },
    {
      "name": "50 Seater Bus Rental Pune",
      "description": "50 Seater Bus Rental Pune maintains a fleet of buses that undergo regular safety and maintenance checks to provide reliable transportation. Whether for short-term or long-term rentals, customers benefit from transparent pricing, flexible terms, and professional drivers who ensure comfortable and safe travel. This rental service supports diverse group travel needs throughout Pune and nearby areas."
    },
    {
      "name": "50 Seater Bus Hire in Hinjewadi",
      "description": "50 Seater Bus Hire in Hinjewadi caters to the corporate and IT sectors, offering reliable transportation for employee commutes, client visits, and corporate events. These buses provide spacious seating and are driven by experienced chauffeurs familiar with local traffic patterns. The service ensures punctuality, cleanliness, and professional conduct to support the busy schedules of Hinjewadi’s workforce."
    },
    {
      "name": "50 Seater Bus Hire in Baner",
      "description": "50 Seater Bus Hire in Baner serves the residential and business communities by providing dependable and comfortable bus rental services. Ideal for group outings, school trips, and corporate events, these buses feature ample luggage space and are maintained to high standards. Skilled drivers ensure timely pickups and courteous service, making group travel in Baner easy and efficient."
    },
    {
      "name": "50 Seater Bus Hire in Pimpri",
      "description": "50 Seater Bus Hire in Pimpri offers affordable and dependable group transportation options for employee commutes, school excursions, family functions, and corporate travel. These buses are well-maintained and driven by professional chauffeurs committed to safety and punctuality. Flexible rental packages accommodate both short and long-term needs, serving the diverse requirements of Pimpri’s population."
    },
    {
      "name": "50 Seater Bus Hire in Hadapsar",
      "description": "50 Seater Bus Hire in Hadapsar provides convenient and reliable bus rental services for social events, office commutes, school trips, and other group travel needs. The fleet consists of clean, well-serviced buses with experienced drivers who ensure safe and timely transportation within Hadapsar and beyond. Customers benefit from flexible booking options and excellent support."
    },
    {
      "name": "50 Seater Bus for School Trip Pune",
      "description": "50 Seater Bus for School Trip Pune specializes in safe and reliable transportation for school excursions, sports events, and educational tours. These buses are equipped with necessary safety features and maintained to high hygiene standards. Drivers trained to handle student groups ensure a secure and comfortable journey, with flexible scheduling and competitive pricing designed to meet educational institutions’ needs."
    },
    {
      "name": "50 Seater Bus for Wedding Pune",
      "description": "50 Seater Bus for Wedding Pune offers elegant and spacious buses designed for wedding guests and related events. The service includes options for vehicle decoration, timely pickups and drop-offs, and professional chauffeurs dedicated to guest comfort and smooth logistics. This service enhances the overall wedding experience with reliable and stylish group transportation."
    },
    {
      "name": "50 Seater Bus for Corporate Pune",
      "description": "50 Seater Bus for Corporate Pune delivers professional transport solutions tailored to corporate schedules and requirements. These buses offer comfortable seating, modern amenities, and are driven by courteous, skilled chauffeurs who understand the importance of punctuality and professionalism. The service supports business travel, client visits, and corporate events with flexible rental terms."
    },
    {
      "name": "Affordable 50 Seater Bus Pune",
      "description": "Affordable 50 Seater Bus Pune provides budget-friendly group transportation without compromising on quality or safety. Ideal for schools, small businesses, family gatherings, and social groups, this service offers transparent pricing, well-maintained vehicles, and professional drivers. Flexible booking options and excellent customer support make it a popular choice among cost-conscious customers."
    },
    {
      "name": "50 Seater Tourist Bus Pune",
      "description": "50 Seater Tourist Bus Pune specializes in buses designed for sightseeing tours, group excursions, and leisure travel around Pune and nearby attractions. These buses come equipped with comfortable seating, ample luggage space, and knowledgeable drivers who often serve as local guides. Customized tour packages and flexible scheduling create an enjoyable and informative travel experience for tourists and group travelers."
    },
    {
      "name": "Online Bus Booking Pune",
      "description": "Online Bus Booking Pune offers a seamless digital platform for reserving 50 seater buses with instant confirmation, multiple payment options, and customizable routes. This service is designed to provide hassle-free booking experiences with 24/7 customer support, allowing travelers to plan and manage group transportation efficiently from anywhere in Pune."
    },
    {
      "name": "50 Seater Bus Hire near Me Pune",
      "description": "50 Seater Bus Hire near Me Pune provides quick access to nearby buses across Pune for both immediate and scheduled group travel needs. The service prioritizes fast response times, well-maintained vehicles, and professional drivers to ensure safe and comfortable rides, making group transportation accessible and convenient for residents citywide."
    },
    {
      "name": "50 Seater Outstation Bus Pune",
      "description": "50 Seater Outstation Bus Pune offers dependable long-distance bus rentals for group travel beyond Pune to nearby cities and tourist destinations. These buses are equipped with spacious seating, adequate luggage capacity, and amenities designed for comfort over extended journeys. Experienced drivers focus on safety and punctuality, ensuring a smooth and enjoyable outstation travel experience."
    }
  ],
  "tableData": [
    ["50 Seater Bus On Rent in Pune", "50 Seater AC Bus Pune"],
    ["50 Seater Non AC Bus Pune", "50 Seater Luxury Bus Pune"],
    ["50 Seater Bus Hire Pune", "50 Seater Bus Rental Pune"],
    ["50 Seater Bus Hire in Hinjewadi", "50 Seater Bus Hire in Baner"],
    ["50 Seater Bus Hire in Pimpri", "50 Seater Bus Hire in Hadapsar"],
    ["50 Seater Bus for School Trip Pune", "50 Seater Bus for Wedding Pune"],
    ["50 Seater Bus for Corporate Pune", "Affordable 50 Seater Bus Pune"],
    ["50 Seater Tourist Bus Pune", "Online Bus Booking Pune"],
    ["50 Seater Bus Hire near Me Pune", "50 Seater Outstation Bus Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "50 Seater Bus On Rent in Pune",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd offers comfortable and affordable 50 seater bus rental services in Pune, ideal for school excursions, weddings, corporate events, and group tours."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Seating",
    "WhyChoosedescription": "Our 50 seater buses come with spacious interiors, cushioned seats, and air conditioning to ensure a smooth and pleasant journey for large groups."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Fleet",
    "WhyChoosedescription": "All our buses are regularly maintained and thoroughly cleaned to guarantee a safe, hygienic, and reliable ride."
  },
  {
    "WhyChooseheading": "Upfront and Transparent Pricing",
    "WhyChoosedescription": "Enjoy competitive rental rates with no hidden charges—everything is clearly communicated at the time of booking."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from hourly, full-day, or long-distance rental options to suit your travel needs and schedule."
  },
  {
    "WhyChooseheading": "Skilled and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers ensure timely pickups, safe driving, and courteous service throughout your journey."
  },
  {
    "WhyChooseheading": "24/7 Customer Assistance",
    "WhyChoosedescription": "Our dedicated customer support team is available round-the-clock to help with reservations, changes, and inquiries."
  },
  {
    "WhyChooseheading": "Easy and Fast Booking Process",
    "WhyChoosedescription": "Book your 50 seater bus quickly online or via phone, with timely service available across Pune and surrounding areas."
  }
]

























  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer 50 seater bus rental services in Pune?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides 50 seater buses on rent in Pune, perfect for large groups, corporate events, and tours.',
  },
  {
    question: 'How can I book a 50 seater bus in Pune with Amruta Travels?',
    answer: 'You can book easily via our website, mobile app, or by contacting our 24×7 customer support team in Pune.',
  },
  {
    question: 'What amenities are available in the 50 seater buses in Pune?',
    answer: 'Our 50 seater buses feature comfortable seating, air conditioning, spacious interiors, and essential safety features for a comfortable journey.',
  },
  {
    question: 'Are the drivers trained and experienced for 50 seater bus hires in Pune?',
    answer: 'Yes, all our drivers are professionally trained, courteous, and experienced in driving 50 seater buses safely around Pune.',
  },
  {
    question: 'Can 50 seater buses be hired for weddings, corporate events, tours, and airport transfers in Pune?',
    answer: 'Absolutely. Our 50 seater buses are ideal for weddings, corporate functions, sightseeing tours, airport transfers, and other group travel needs.',
  },
  {
    question: 'Is the 50 seater bus hire service available 24×7 in Pune?',
    answer: 'Yes, Amruta Travels offers 24×7 availability for 50 seater bus hire services in Pune to fit your schedule.',
  },
  {
    question: 'What safety and hygiene measures are followed for 50 seater bus hires?',
    answer: 'All buses are sanitized before every trip, and our drivers follow strict hygiene and safety protocols to ensure your well-being.',
  },
  {
    question: 'What are the payment options for 50 seater bus rental in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available throughout the 50 seater bus rental period in Pune?',
    answer: 'Yes, our 24×7 customer support team is available to assist you anytime during your rental period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Suresh Patil',
    feedback: 'The 50 seater bus from Amruta Travels Pune was spacious and comfortable. The driver was professional and punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priyanka Joshi',
    feedback: 'Great service and a well-maintained bus. The 50 seater bus was perfect for our corporate event in Pune.',
    rating: 5,
  },
];































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "50 Seater Bus On Rent in Pune",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/11.jpg",
  "description": "Book a 50 Seater Bus On Rent in Pune with Amruta Travels Pvt. Ltd. offering AC, Non-AC, and Luxury buses for school trips, weddings, corporate events, and outstation travel. Reliable and affordable 50 seater bus rental service in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "15987"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/50-seater-bus-on-rent-in-pune"
  }
};








  return (
    <div>
<Helmet>
  <title>50 Seater Bus On Rent in Pune | AC & Luxury Bus Hire | Amruta Travels Pvt. Ltd.</title>
  <meta
    name="description"
    content="Book 50 Seater Bus On Rent in Pune with Amruta Travels Pvt. Ltd. Choose from AC, Non-AC, and Luxury buses for school trips, weddings, corporate events, and outstation travel. Affordable and reliable bus rentals in Pune."
  />
  <meta
    name="keywords"
    content="50 Seater Bus On Rent in Pune, 50 Seater AC Bus Pune, 50 Seater Non AC Bus Pune, 50 Seater Luxury Bus Pune, 50 Seater Bus Hire Pune, 50 Seater Bus Rental Pune, 50 Seater Bus Hire in Hinjewadi, 50 Seater Bus Hire in Baner, 50 Seater Bus Hire in Pimpri, 50 Seater Bus Hire in Hadapsar, 50 Seater Bus for School Trip Pune, 50 Seater Bus for Wedding Pune, 50 Seater Bus for Corporate Pune, Affordable 50 Seater Bus Pune, 50 Seater Tourist Bus Pune, Online Bus Booking Pune, 50 Seater Bus Hire near Me Pune, 50 Seater Outstation Bus Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/11.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Fiftyseaterbusonrentinpune;